import { Skeleton } from 'primereact/skeleton';

const EditOpportunitySkeletonLoader = () => {
  return (
    <div style={{ width: '100%', height: '100%', display: 'flex' }}>
      <div
        style={{
          width: '50%',
          padding: '0.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <div>
          <Skeleton height="4rem" width="100%" style={{ borderRadius: '0.5rem' }} />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: '1rem',
          }}
        >
          <Skeleton height="5.5rem" width="100%" style={{ borderRadius: '0.5rem' }} />
          <Skeleton height="5.5rem" width="100%" style={{ borderRadius: '0.5rem' }} />
        </div>

        <Skeleton height="13rem" width="100%" style={{ borderRadius: '0.5rem' }} />
        <Skeleton height="7rem" width="100%" style={{ borderRadius: '0.5rem' }} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: '1rem',
          }}
        >
          <Skeleton height="3rem" width="100%" style={{ borderRadius: '0.5rem' }} />
          <Skeleton height="3rem" width="100%" style={{ borderRadius: '0.5rem' }} />
        </div>
        <Skeleton height="2rem" width="100%" style={{ borderRadius: '0.5rem' }} />
        <Skeleton height="2rem" width="100%" style={{ borderRadius: '0.5rem' }} />
      </div>
      <div
        style={{
          width: '50%',
          padding: '0.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <Skeleton height="13rem" width="100%" style={{ borderRadius: '0.5rem' }} />
        <Skeleton height="3rem" width="100%" style={{ borderRadius: '0.5rem' }} />
        <Skeleton height="3rem" width="100%" style={{ borderRadius: '0.5rem' }} />
        <Skeleton height="3rem" width="100%" style={{ borderRadius: '0.5rem' }} />
        <Skeleton height="3rem" width="100%" style={{ borderRadius: '0.5rem' }} />
        <Skeleton height="3rem" width="100%" style={{ borderRadius: '0.5rem' }} />
      </div>
    </div>
  );
};

export default EditOpportunitySkeletonLoader;
